import type { AxiosRequestConfig } from 'axios';
import { axios as axiosInstance, getAccessToken } from 'utils/common';

// Generated paths are `/api/...`; existing axios baseURL already ends with `/api`.
const micServiceBaseUrl = (process.env.REACT_APP_WEB_API_URL || '').replace(/\/api\/?$/, '');

export const customInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const token = getAccessToken();

  return axiosInstance({
    ...config,
    ...options,
    baseURL: micServiceBaseUrl,
    headers: {
      ...config.headers,
      ...options?.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  }).then(({ data }) => data as T);
};

export default customInstance;
